import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import {makeStyles} from '@material-ui/styles';
import clsx from 'clsx';
import React, {useState} from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import {T} from 'react-polyglot-hooks';
import {Link as RouterLink} from 'react-router-dom';
import Label from '../../../components/Label';
import {WcvLogLevels} from '../../../graphql/logs.datatypes';
import {EST, formatDateTime} from '../../../utils/formatters';

import getPriorityLogs from './getPriorityLogs.api';
import LogDetailsModal from '../../Logs/LogDetailsModal';

const useStyles = makeStyles(() => ({
  root: {},
  content: {
    padding: 0
  },
  inner: {
    minWidth: 800
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const PriorityLogs = (props: { className?: string }) => {
  const {className, ...rest} = props;
  const logsData = getPriorityLogs();
  const classes = useStyles();
  const [selectedLog, setSelectedLog] = useState();

  return (
    <Card
      {...rest}
      className={clsx(classes.root, className)}
    >
      <CardHeader title="Priority Logs"/>
      <Divider/>
      <CardContent className={classes.content}>
        <PerfectScrollbar>
          <div className={classes.inner}>
            {logsData.loading && (
              <Typography><T phrase="Loading..."/></Typography>
            )}
            {!logsData.loading && (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell style={{width: 215}}><T phrase="Timestamp"/></TableCell>
                    <TableCell style={{width: 100}}><T phrase="Level"/></TableCell>
                    <TableCell><T phrase="Description"/></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {logsData.data!.logs.data.map(log => {
                    const logLevel = WcvLogLevels[log.level];

                    return (
                      <TableRow hover key={log.id} onClick={() => setSelectedLog(log)}>
                        <TableCell>{formatDateTime(log.created_at)}</TableCell>
                        <TableCell><Label color={logLevel.colour}>{logLevel.name}</Label></TableCell>
                        <TableCell>{log.description}</TableCell>
                      </TableRow>
                    )
                  })}
                </TableBody>
              </Table>
            )}
            </div>
          </PerfectScrollbar>

        {selectedLog && (<LogDetailsModal log={selectedLog} setSelectedLog={setSelectedLog}/>)}
      </CardContent>
      <Divider/>
      <CardActions className={classes.actions}>
        <Button color="primary" size="small" variant="text" component={RouterLink} to="/logs">
          <T phrase="View all" /> <ArrowRightIcon/>
        </Button>
      </CardActions>
    </Card>
  );
};

export default PriorityLogs;
